// src/components/modals/WelcomeModal.js
import React from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';

const WelcomeModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-md">
            <div className="p-8 text-center">
                <h2 className="text-3xl font-bold text-white mb-4">Bem-vindo ao V-Flow!</h2>
                <p className="text-gray-300 mb-6">
                    Tudo pronto para você organizar suas tarefas e decolar sua produtividade.
                </p>
                <GlassButton 
                    onClick={onClose} 
                    className="bg-indigo-500 text-white font-semibold py-2 px-8 rounded-full shadow-lg hover:bg-indigo-600 transition-colors duration-200"
                >
                    Vamos começar!
                </GlassButton>
            </div>
        </Modal>
    );
};

export default WelcomeModal;